/**
 * @generated SignedSource<<779ec6a93ab49c2fec421340bf5f7087>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type RecurrenceFrequency = "DAILY" | "MONTHLY" | "WEEKLY" | "YEARLY";
export type RoutineNotificationStrategy = "DISABLED" | "STANDARD";
export type RoutineScheduleType = "DAILY" | "MONTHLY" | "WEEKLY";
export type TaskImportance = "OPTIONAL" | "REQUIRED";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type UpdateRoutineInput = {
  addDescriptionFileIds?: ReadonlyArray<string> | null;
  addDescriptionImageIds?: ReadonlyArray<string> | null;
  addDescriptionMediaIds?: ReadonlyArray<string> | null;
  addDescriptionVideoIds?: ReadonlyArray<string> | null;
  assignedRoleIds?: ReadonlyArray<string> | null;
  createConnections?: ReadonlyArray<AddConnection> | null;
  createSections?: ReadonlyArray<UpdateRoutineCreateSectionInput> | null;
  createTasks?: ReadonlyArray<CreateTaskInput> | null;
  deleteSections?: ReadonlyArray<RemoveSection> | null;
  removeConnections?: ReadonlyArray<RemoveTaskConnection> | null;
  removeDescriptionFileIds?: ReadonlyArray<string> | null;
  removeDescriptionImageIds?: ReadonlyArray<string> | null;
  removeDescriptionMediaIds?: ReadonlyArray<string> | null;
  removeDescriptionVideoIds?: ReadonlyArray<string> | null;
  setDescription?: string | null;
  setNotificationStrategy?: RoutineNotificationStrategy | null;
  setOrgTopicId?: string | null;
  setSchedule?: ScheduleInput | null;
  setSectionOrder?: ReadonlyArray<string> | null;
  setTeamId?: string | null;
  setTitle?: string | null;
  updateSchedule?: RoutineScheduleInput | null;
  updateSections?: ReadonlyArray<UpdateSectionInput> | null;
  updateTasks?: ReadonlyArray<UpdateRoutineUpdateTaskInput> | null;
};
export type AddConnection = {
  check?: CreateTaskSectionConnetion | null;
  number?: CreateTaskNumberExistingSectionConnetion | null;
  text?: CreateTaskSectionConnetion | null;
};
export type CreateTaskSectionConnetion = {
  canBeDisabled?: boolean | null;
  sectionId: string;
  taskId: string;
  topicId?: string | null;
};
export type CreateTaskNumberExistingSectionConnetion = {
  canBeDisabled?: boolean | null;
  greaterThan?: number | null;
  lessThan?: number | null;
  sectionId: string;
  taskId: string;
  topicId?: string | null;
};
export type UpdateRoutineCreateSectionInput = {
  canBeDisabled?: boolean | null;
  id: string;
  orgTopicId?: string | null;
  teamId?: string | null;
  title?: string | null;
};
export type CreateTaskInput = {
  check?: CreateTaskCheckInput | null;
  number?: CreateTaskNumberInput | null;
  text?: CreateTaskTextInput | null;
};
export type CreateTaskCheckInput = {
  id: string;
  imageIds?: ReadonlyArray<string> | null;
  instructions?: string | null;
  sentiments?: ReadonlyArray<TaskSentiment> | null;
  title?: string;
};
export type CreateTaskNumberInput = {
  id: string;
  imageIds?: ReadonlyArray<string> | null;
  instructions?: string | null;
  suffix?: string | null;
  title: string;
  unit?: NumberTaskUnit | null;
};
export type CreateTaskTextInput = {
  id: string;
  imageIds?: ReadonlyArray<string> | null;
  instructions?: string | null;
  title?: string;
};
export type RemoveSection = {
  sectionId: string;
};
export type RemoveTaskConnection = {
  sectionId: string;
  taskId: string;
};
export type ScheduleInput = {
  rules: ReadonlyArray<RecurrenceRuleInput>;
  type?: RoutineScheduleType | null;
  tzid?: string | null;
};
export type RecurrenceRuleInput = {
  byhour?: ReadonlyArray<number> | null;
  byminute?: ReadonlyArray<number> | null;
  bymonth?: ReadonlyArray<number> | null;
  bymonthday?: ReadonlyArray<number> | null;
  bysecond?: ReadonlyArray<number> | null;
  byweekday?: ReadonlyArray<number> | null;
  byweekno?: ReadonlyArray<number> | null;
  byyearday?: ReadonlyArray<number> | null;
  dtstart?: string | null;
  duration?: number | null;
  freq: RecurrenceFrequency;
  interval?: number | null;
  isAllDay?: boolean | null;
  tasks: ReadonlyArray<RecurrenceRuleTaskDescriptionInput>;
  until?: string | null;
  wkst?: number | null;
};
export type RecurrenceRuleTaskDescriptionInput = {
  importance: TaskImportance;
  taskId: string;
};
export type RoutineScheduleInput = {
  daily?: RoutineScheduleDailyInput | null;
  monthly?: RoutineScheduleMonthlyInput | null;
  weekly?: RoutineScheduleWeeklyInput | null;
};
export type RoutineScheduleDailyInput = {
  deadlineDuration?: number | null;
  isAllDay?: boolean | null;
  weekdays: ReadonlyArray<RoutineScheduleDailyWeekdayInput>;
};
export type RoutineScheduleDailyWeekdayInput = {
  startTime?: TimeInput | null;
  tasks: ReadonlyArray<RoutineScheduleTaskImportanceInput>;
  weekday: number;
};
export type TimeInput = {
  hour: number;
  minute: number;
};
export type RoutineScheduleTaskImportanceInput = {
  importance: TaskImportance;
  taskId: string;
};
export type RoutineScheduleMonthlyInput = {
  endDay?: number | null;
  months: ReadonlyArray<number>;
  startDay: number;
};
export type RoutineScheduleWeeklyInput = {
  endWeekday?: number | null;
  startTime?: TimeInput | null;
  startWeekday?: number | null;
  weeks?: ReadonlyArray<number> | null;
};
export type UpdateSectionInput = {
  sectionId: string;
  setCanBeDisabled?: boolean | null;
  setOrgTopicId?: string | null;
  setTaskOrder?: ReadonlyArray<string> | null;
  setTeamId?: string | null;
  setTitle?: string | null;
  unsetOrgTopicId?: boolean | null;
  unsetTeamId?: boolean | null;
};
export type UpdateRoutineUpdateTaskInput = {
  check?: UpdateTaskCheckInput | null;
  number?: UpdateTaskNumberInput | null;
  taskId: string;
  text?: UpdateTaskTextInput | null;
};
export type UpdateTaskCheckInput = {
  setImageIds?: ReadonlyArray<string> | null;
  setInstructions?: string | null;
  setSentiments?: ReadonlyArray<TaskSentiment> | null;
  setTitle?: string | null;
};
export type UpdateTaskNumberInput = {
  setImageIds?: ReadonlyArray<string> | null;
  setInstructions?: string | null;
  setTitle?: string | null;
  setUnit?: NumberTaskUnit | null;
};
export type UpdateTaskTextInput = {
  setImageIds?: ReadonlyArray<string> | null;
  setInstructions?: string | null;
  setTitle?: string | null;
};
export type useKPIEditSectionsSaveMutation$variables = {
  input: UpdateRoutineInput;
  routineId: string;
};
export type useKPIEditSectionsSaveMutation$data = {
  readonly routine: {
    readonly update: {
      readonly routine: {
        readonly id: string;
      } | null;
    } | null;
  } | null;
};
export type useKPIEditSectionsSaveMutation = {
  response: useKPIEditSectionsSaveMutation$data;
  variables: useKPIEditSectionsSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routineId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "routineId"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "UpdateRoutinePayload",
        "kind": "LinkedField",
        "name": "update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routine",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useKPIEditSectionsSaveMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useKPIEditSectionsSaveMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5eeb4556f48eb60c04081d48f8fd0d48",
    "id": null,
    "metadata": {},
    "name": "useKPIEditSectionsSaveMutation",
    "operationKind": "mutation",
    "text": "mutation useKPIEditSectionsSaveMutation(\n  $routineId: ID!\n  $input: UpdateRoutineInput!\n) {\n  routine(id: $routineId) {\n    update(input: $input) {\n      routine {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "edd9debdea7fbb1f0622c7b4cf08f2b0";

export default node;
